import styled from 'styled-components'
import AntdModal from 'antd/lib/modal'
import Icon from 'antd/lib/icon'

export const Modal = styled(AntdModal)`
  .ant-modal-body {
    padding: unset;
  }
`

export const InitalStateContainer = styled.div`
  display: flex;
  font-size: 12px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const InitialStateTextContent = styled.div`
  width: 50%;
  margin: 8px 16px;
  display: flex;
  flex-flow: column;
  @media (max-width: 768px) {
    width: 100%;
    margin: unset;
    padding: 8px 16px;
  }
`

export const InitialStateMediaContent = styled.div`
  width: 50%;
  margin: 8px 16px;
  img {
    width: 100%;
    height: inherit;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin: unset;
    padding: 0px 16px 12px;
    justify-content: center;
    display: flex;
    img {
      width: 66%;
      max-width: 312px;
    }
  }
`

export const ModalTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 12px;
  margin-top: 16px;
  font-family: Avenir;
`

export const ParagraphContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 14px;
`

export const ContinueButtonContainer = styled.div<{ $isMobile: boolean }>`
  display: ${props => props.$isMobile ? 'none' : 'flex'};
  width: 100%;
  justify-content: center;
  padding-bottom: 12px;
  @media (max-width: 768px) {
    display: ${props => props.$isMobile ? 'flex' : 'none'};
  }
`

export const ContinueButton = styled.div`
  text-transform: uppercase;
  color: white;
  background-color: cornflowerblue;
  border-radius: 4px;
  padding: 5px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  box-shadow: 0px 1px 3px 0px #919191;
  &:hover {
    cursor: pointer;
    opacity: 0.7
  }
  @media (max-width: 768px) {
    margin: 0px 16px
  }
`

export const ColorBaseContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 614px;
  column-gap: 16px;
  row-gap: 24px;
  padding-bottom: 32px;
  .slick-slider {
    display: inline-grid;
  }
  .slick-arrow {
    background: white;
    border-radius: 25px;
  }
  .slick-next:before, .slick-prev:before {
    color: #375886;
    opacity: 1;
    line-height: 1.1;
  }
`

export const MediaName = styled.h6`
  display: block;
  font-size: 12px;
  padding-top: 6px;
  height: 30px
  text-align: center;
`

export const ColorImageContainer = styled.div`
  width: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 1px 3px 1px #d3d3d3;
  border-radius: 3px;
  border: ${({ secondary }: { secondary: boolean }) => secondary ? '2px solid cornflowerblue' : 'unset'};
  animation: scale-in-center 0.075s cubic-bezier(0.250, 0.460, 0.450, 0.940) 
    ${({ index }: any) => `${index ? (index * 0.1) : '1'}s`} both;
  @keyframes scale-in-center {
    0% {
      transform: scale(0.95);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  transition: all .25s;
  overflow: hidden;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    width: 120px;
  }
`

export const VinylImageContainer = styled.div`
  width: 172px !important;
  height: 320px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 8px 14px;
  border: ${({ secondary }: { secondary: boolean }) => secondary ? '2px solid cornflowerblue' : 'unset'};
  animation: scale-in-center 0.075s cubic-bezier(0.250, 0.460, 0.450, 0.940) 
    ${({ index }: any) => `${index ? (index * 0.1) : '1'}s`} both;
  @keyframes scale-in-center {
    0% {
      transform: scale(0.95);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  box-shadow: 0px 1px 3px 1px #d3d3d3;
  border-radius: 3px;
  transition: all .25s;
  overflow: hidden;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    width: 136px !important;
  }
`

export const BackBtn = styled.div`
  background: white;
  width: fit-content;
  padding: 8px 22px;
  border-radius: 5px;
  box-shadow: 0px 1px 3px 0px #919191;
  margin-right: 30px;
  font-size: 14px;
  font-weight: bold;
  &:hover {
    cursor: pointer;
    opacity: 0.7
  }
  @media (max-width: 698px) {
    margin-left: 32px;
  }
`

export const CloseIcon = styled(Icon)`
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  background: white;
  border-radius: 25px;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/OmegaModal/styledComponents.tsx